import { Image, StyleSheet, Text, View, ScrollView } from 'react-native'
import { ThemedView, ThemedText } from '@app/theme'
import ShieldCheckIcon from '@app/assets/svg/ShieldCheckIcon'
import Button from '@app/sharedComponents/Button/Button'
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet'
import ContactUs from '../UserProfile/ContactUs'
import { useEffect, useState } from 'react'
import { trackEvent } from '@app/utils/amplitude'
import { updatePartnerParams } from '@app/store/slices/platformSlice'
import { useAppDispatch, useAppSelector } from '@app/store/hooks'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { PrivateStackParamList } from '@app/navigationApp/types'
import { APPLICATION_STATUS } from '@app/utils'
import LogOutUser from '@app/helper/logout'
import SystemWarning from '../../../assets/Icons/SystemWarning';

type AccountBlockedProps = NativeStackScreenProps<PrivateStackParamList, 'BLOCKED'>;


const AccountBlocked = ({route} :AccountBlockedProps ) => {

  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const dispatch = useAppDispatch();

  const applicationState = useAppSelector(state => state?.auth?.userDetails?.linkedApplications[0]?.applicationState)
  const isDenied = applicationState === APPLICATION_STATUS.DENIED || route?.params?.applicationState === APPLICATION_STATUS.DENIED;


  useEffect(() => {
    dispatch(updatePartnerParams({showCall:true}))
  }, [])

  const closeBottomSheet = () => {
    setIsBottomSheetVisible(false);
  }

  return (
    <ThemedView flex={1} bg='bg-surface-primary'>
      <ScrollView contentContainerStyle={{ alignItems: 'center', justifyContent: 'center', flex: 1 }}>
        {isDenied ? (
          <SystemWarning size={64} />
        ) : (
          <Image
            style={{ width: 164, height: 164 }}
            source={{ uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verifying_details.png' }}
          />
        )}
        {isDenied ? (
          <ThemedText mt='2xl' variant='h5s' color='text-primary'>Your application was rejected by our lending partner</ThemedText>
        ) : (
          <ThemedText mt='2xl' variant='h5s' color='text-primary'>Your application is under review</ThemedText>
        )}
        <ThemedView bg='bg-fill-warning' mx='lg' borderRadius='sm' padding='md' mt='md'>
          {isDenied ? (
            <ThemedText textAlign='center' variant='b3r' color='text-primary'>Your credit profile currently does not meet the policy guidelines of our lending partner.</ThemedText>
          ) : (
            <ThemedText textAlign='center' variant='b3r' color='text-primary'>Your application is currently on hold. However, we are actively assessing it. You should receive a response within 2 business hours.</ThemedText>
          )}
        </ThemedView>
      </ScrollView>
      <ThemedView borderTopWidth={1} borderColor='border-secondary' padding='lg' bg='bg-surface-primary'>
        <ThemedView mb='lg' flexDirection='row' justifyContent='center' alignItems='center'>
          <ShieldCheckIcon size={14} />
          <ThemedText textAlign='center' ml='sm' color='text-emphasis-secondary' variant='b4r'>
            Your data is secure with us
          </ThemedText>
        </ThemedView>
        <Button
          size='MD'
          handlePress={() => {
            trackEvent('ACCOUNT_BLOCKED_CONTACT_US_CLICKED');
            setIsBottomSheetVisible(true)}
          }
          bg='bg-action'
          textColor='text-white'
          label='Need help? Contact us'
          buttonLoader={false}
        />
        <ThemedView height={12} />
        <Button
          size='MD'
          type='OUTLINED'
          handlePress={() => {
            trackEvent('ACCOUNT_BLOCKED_LOGOUT_CLICKED');
            LogOutUser()
          }
          }
          bg='bg-action'
          textColor='text-white'
          label='Logout'
          buttonLoader={false}
        />
      </ThemedView>

      <BottomSheetContainer
        showCloseIcon={true}
        isVisible={isBottomSheetVisible}
        close={closeBottomSheet}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        onClose={closeBottomSheet}
        dragComponent={<View style={{ width: 40, height: 4, backgroundColor: 'gray', borderRadius: 10 }} />}
        containerStyle={{ backgroundColor: 'white' }}
        containsTextInput={true}
        >
        <ContactUs />
      </BottomSheetContainer>

    </ThemedView>
  )
}

export default AccountBlocked
